import Vue from "vue";
import ResourceService from "./resource.service";

class ClientService extends ResourceService {
  static get resource() {
    return "client";
  }

  static download(params = {}) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(`${this.resource}/download`, {
          responseType: "blob",
          params,
        })
        .then(({ data }) => {
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export default ClientService;
